import { reducerWithInitialState } from "typescript-fsa-reducers";

import { Company, Image, EntitiesMap } from "../entities";

import {
  bootstrapCompanyShow,
  bootstrapCompanyAbout,
  bootstrapCompanyMembers,
  bootstrapCompanyPosts,
  bootstrapCompanyProjects,
  draftCompanyUpdated,
  draftCompanyAvatarUpdated,
  draftCompanyBackgroundUpdated,
  saveDraftAll,
  saveDraftCompany,
  editModeStarted,
  editModeFinished,
  draftReset,
} from "../actions";

export interface CommonState {
  companyId: string;
  editMode: boolean;
  isDraftCompanyDirty: boolean;
  draftCompany?: Company;
  draftCompanyAvatar?: Image;
  draftCompanyBackground?: Image;
  isSavingDraft: boolean;
}

const initialState: CommonState = {
  companyId: "",
  editMode: false,
  isDraftCompanyDirty: false,
  isSavingDraft: false,
};

function buildDraftCompany(companyId: EntityId, entities: EntitiesMap) {
  const draftCompany = entities.companies[companyId];
  const draftCompanyAvatar = draftCompany ? entities.images[draftCompany.avatar] : undefined;
  const draftCompanyBackground =
    draftCompany && draftCompany.background ? entities.images[draftCompany.background] : undefined;
  return {
    draftCompany,
    draftCompanyAvatar,
    draftCompanyBackground,
  };
}

const commonReducer = reducerWithInitialState<CommonState>(initialState)
  .cases(
    [
      bootstrapCompanyShow,
      bootstrapCompanyAbout,
      bootstrapCompanyMembers,
      bootstrapCompanyPosts,
      bootstrapCompanyProjects,
    ],
    (state, { result, entities }) => {
      return {
        ...state,
        companyId: result.company,
        isDraftCompanyDirty: false,
        ...buildDraftCompany(result.company, entities),
      };
    }
  )
  .case(draftReset, (state, entities) => {
    return { ...state, isDraftCompanyDirty: false, ...buildDraftCompany(state.companyId, entities) };
  })
  .case(draftCompanyUpdated, (state, company) => {
    return {
      ...state,
      draftCompany: company,
      isDraftCompanyDirty: true,
    };
  })
  .case(draftCompanyAvatarUpdated, (state, image) => {
    return {
      ...state,
      draftCompanyAvatar: image,
      isDraftCompanyDirty: true,
    };
  })
  .case(draftCompanyBackgroundUpdated, (state, image) => {
    return {
      ...state,
      draftCompanyBackground: image,
      isDraftCompanyDirty: true,
    };
  })
  .case(saveDraftAll.started, state => {
    return {
      ...state,
      isSavingDraft: true,
    };
  })
  .case(saveDraftAll.done, state => {
    return {
      ...state,
      isSavingDraft: false,
    };
  })
  .case(saveDraftAll.failed, state => {
    return {
      ...state,
      isSavingDraft: false,
    };
  })
  // TODO(KentoMoriwaki): Handle saveDraftCompany.failed
  .case(saveDraftCompany.done, (state, { result: { result, entities } }) => {
    return {
      ...state,
      isDraftCompanyDirty: false,
      ...buildDraftCompany(result, entities),
    };
  })
  .case(editModeStarted, state => {
    return { ...state, editMode: true };
  })
  .case(editModeFinished, state => {
    return { ...state, editMode: false };
  });

export default commonReducer;



// WEBPACK FOOTER //
// ./frontend/src/companies/reducers/common.ts